module.exports = __webpack_public_path__ + "entry-150bfe9b/otto-photo-d73b234573f5d17d4083715bc3baf0ea.webp";